/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate the future value of a one-time (lump-sum) investment. Enter the amount, expected annual return and time period.`)
};

const es_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima el valor futuro de una inversión única (de suma única). Ingresa la cantidad, retorno anual esperado y período de tiempo.`)
};

const de_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzen Sie den zukünftigen Wert einer einmaligen (Pauschal-)Anlage. Geben Sie den Betrag, die erwartete jährliche Rendite und den Zeitraum ein.`)
};

const nl_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat de toekomstige waarde van een eenmalige (vervangings)belegging. Voer het bedrag, verwacht jaarlijks rendement en periode in.`)
};

const fr_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez la valeur future d'un investissement unique (versement unique). Entrez le montant, le rendement annuel attendu et la période.`)
};

const it_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il valore futuro di un investimento una tantum (investimento forfettario). Inserisci l'importo, il rendimento annuale atteso e il periodo di tempo.`)
};

const pt_br2_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o valor futuro de um investimento único (investimento de uma só vez). Digite o valor, retorno anual esperado e período de tempo.`)
};

const pt_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o valor futuro de um investimento único (montante único). Introduza o montante, retorno anual esperado e período de tempo.`)
};

const ja_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワンタイム（一括）投資の将来価値を推定します。金額、期待年率、投資期間を入力してください。`)
};

const zh_sip_lumpsum_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`估算一次性投资的未来价值。输入金额、预期年回报率和投资期限。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_intro", locale)
	if (locale === "en") return en_sip_lumpsum_intro(inputs)
	if (locale === "es") return es_sip_lumpsum_intro(inputs)
	if (locale === "de") return de_sip_lumpsum_intro(inputs)
	if (locale === "nl") return nl_sip_lumpsum_intro(inputs)
	if (locale === "fr") return fr_sip_lumpsum_intro(inputs)
	if (locale === "it") return it_sip_lumpsum_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_intro(inputs)
	if (locale === "pt") return pt_sip_lumpsum_intro(inputs)
	if (locale === "ja") return ja_sip_lumpsum_intro(inputs)
	return zh_sip_lumpsum_intro(inputs)
};